import { defaultFor } from "common/index";
import { Properties } from "common/types/records";
import type { Entity } from "common/entities/types";
import type { WorkOrderActionRecord } from "common/record/actions/ui/work-order-action/types";
import { hasMissingRequiredProperties } from "common/record/actions/ui/work-order-action/required-entities/functions";
import { getFormOrDefault } from "common/record/edit/functions";
// eslint-disable-next-line import/no-cycle
import { RelatedRecordsForm } from "common/record/form/content/related";
import { RelatedValue } from "common/record/form/content/related/types";
import { RelatedUiValue } from "common/record/types";
import { Context } from "common/types/context";
import { AlertWarning } from "common/widgets/alert";
import { OnChange } from "common/with-value-for";

interface TabContentProps {
  context: Context;
  parentEntity: Entity;
  entity: Entity;
  record: WorkOrderActionRecord;
  hasMissingRecords: boolean;
  onChange: OnChange<RelatedUiValue>;
}

export const TabContent = ({
  context,
  parentEntity,
  entity,
  record,
  hasMissingRecords,
  onChange,
}: TabContentProps) => {
  const formId = record?.related?.[entity.name]?.[0]?.properties?.formId;
  const form = getFormOrDefault(context, entity.name, formId);

  const entityLayout = form?.settings?.relatedEntities?.find(
    (re) => re.name === entity.name,
  );

  const onRelatedChange = (data: RelatedValue) => {
    onChange(data.related);
  };

  const isRecordInvalid = (properties: Properties) =>
    hasMissingRequiredProperties(entity, form, properties);

  return (
    <>
      {hasMissingRecords && (
        <AlertWarning
          className="x-margin-bottom-15-i"
          message={_(
            "This required related entity requires at least one record, and all records must have all required fields completed.",
          )}
        />
      )}
      <RelatedRecordsForm
        context={context}
        parentEntity={parentEntity}
        entity={entity}
        recordId={record.id}
        entityConfig={entityLayout}
        reload={undefined}
        recordDetail={undefined}
        displayTypes={["actions", "form", "table"]}
        isTemplate={false}
        isRecordInvalid={isRecordInvalid}
        value={{
          record: record?.fullRecord ?? {
            actions: [],
            properties: record?.properties,
            related: record?.related ?? defaultFor(),
          },
          related: record?.relatedUiValue ?? defaultFor(),
          sidebar: { label: "" },
        }}
        onChange={onRelatedChange}
      />
    </>
  );
};
